module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fma"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To my friend, Mary Abreu, the Craft Addict. “Thank you” seems inadequate. Your guidance, advice, and friendship have meant more to me than I can ever express. I couldn’t have done this without you.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To Roxane Cerda for believing in my idea and helping make this possible.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To Karla Menaugh, Sadhana Wray, and everyone at C&T who helped me create a book I’ve wanted to write for ten years.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("Thank you, Andover Fabrics, Dear Stella Design, Michael Miller Fabrics, and Westminster Fibers, for all the fabric you supplied.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("Thank you to Aurifil for sending me your amazing thread.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("A big thank-you to Sarah Phillips at Intown Quilters for letting me teach at your shop and for all your support. I’m lucky that you took a chance on me so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To the cheerleaders, old and new, that I always have surrounding me: Hope Goldberg, Merry Bentley-Barlow, Hannah Burke, Ingie Derouin, Elizabeth Durel, Amy Higgins, Jacqueline Johnson, Callie Kaiser, Marnie Katz, Kendra Sanderson, Lauren Surden, and Ro Lawson. Your words of encouragement never fell on deaf ears. I love each of you dearly.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To Taffy McLaughlin for being such a great mentor over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To my mother-in-law, Claire, for all your support and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("To my dad, Mike, for always encouraging me to follow my dreams, and to my sister, Laura, for never wanting to learn how to sew.")]), _vm._v(" "), _c('p', {
    staticClass: "ackp"
  }, [_vm._v("Most of all, to my husband, Mike, and our boys, Sean and Quinn, for tolerating all the missed meals, dirty laundry, and late nights while I wrote this book. I love you!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8a3832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ack.vue
// module id = 66
// module chunks = 0